import { render } from "./page-dpp-new.vue?vue&type=template&id=12c8f85d"
import script from "./page-dpp-new.js?vue&type=script&lang=js"
export * from "./page-dpp-new.js?vue&type=script&lang=js"

import "./page-dpp-new.vue?vue&type=style&index=0&id=12c8f85d&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__